export const ROUTE_CONFIG = {
	LOGIN: "/login",
	REGISTRATION: "/registration",
	REGISTER: "/register",
	TFA: "/2fa",
	ACCEPT_INVITATION: "/accept-invitation",
	CHANGE_PASSWORD: "/change-password",
	CHECK_EMAIL: "/check-email",
	CONFIRM_EMAIL: "/confirm-email",
	LOGOUT: "/logout",
	FORGOT_PASSWORD: "/forgot-password",
	ERROR_PAGE: "/error-page",
	ACCOUNT: "/app/account",
	COMPANY: "/app/company",
	USERS: "/app/users",
	USER_ROLES: "/app/users/user-roles",
	COMPANIES: "/app/companies",
	ACCOUNTS: "/app/accounts",
	COMPANY_MANAGEMENT: "/app/company-management",
	TO_DO_LIST: "/app/to-do",
	TO_DO_LIST_2: "/app/to-do-2",
	MANAGE_TO_DO: "/app/to-do/manage",
	MANAGE_QUESTIONNAIRE: "/app/questionnaire",
	MANAGE_INDUSTRIES: "/app/industries",
	MANAGE_COMPANY_SIZE: "/app/company-sizes",
	MANAGE_COMPANY_REVENUE: "/app/company-revenues",
	MANAGE_COMPANY_BALANCE: "/app/company-balances",
	MANAGE_TASK_TEMPLATES: "/app/task-templates",
	TEAM: "/app/team",
	QUESTIONNAIRE: "/questionnaire/:initial?",
	HOME: "/",
	SET_PASSWORD: "/set-password",
	DOWNLOAD: "/download",
	PRODUCT: "/produkt",
	PRICING: "/preise",
	QUICK_CHECK: "/schnellcheck",
	ABOUT: "/ueber-uns",
	CONTACT: "/kontakt",
	PRIVACY: "/datenschutz",
};

export const PUBLIC_PAGES_AFTER_LOGIN = [ROUTE_CONFIG.FORGOT_PASSWORD];
